import ReactDOM from 'react-dom';
import UPshowState from '../UPshowState';
import StateFactory from '../StateFactory';
import MediaChannelVOD from './MediaChannelVOD';
import JukinService from '../../services/JukinService';
import _get from 'lodash/get';
import { getToken } from '../../Upshow';
import HwFeatureService from '../../services/HwFeatureService';

export default class MediaChannelVODState extends UPshowState {
    constructor (node, state) {
        super(
            node,
            state,
            null,
            false,
            true,
            { track: false }
        );

        this.state.channel = {
            id: _get(this.state, 'state.itemId', null)
        };

        if (!this.state.channel.id) {
            const schedule = JukinService.getNextScheduleItem();
            if (!schedule) {
                throw new StatePreconditionError('Error loading MediaChannel VOD without a valid schedule');
            }
            this.state.channel = {
                id: schedule.channel_id
            };
        }

        this.metricData = { ...this.metricData, id: parseInt(this.state.channel.id) };
    }

    get name () {
        return 'media_channel_vod';
    }

    playerError = false;

    onError = (error) => {
        const message = error.message || error.detail;
        this.raiseError(message)
        this.playerError = true;
    };

    solveError = async (message) => {
        console.log('Fatal player error solved', message);
        this.playerError = false;
        await this.renderMediaChannelVOD();
    };

    async validatePlaylist(url) {
        const response = await fetch(url);
        const playlist = await response.text();
        if (response.status === 404) this.raiseSkip(playlist);
        if (!playlist || !playlist.includes('#EXTM3U')) this.raiseSkip('Invalid playlist');
    }

    async renderMediaChannelVOD () {
        try { 
            ReactDOM.unmountComponentAtNode(this.node); 
        } catch {}

        const channelId = encodeURIComponent(this.state.channel.id);
        const baseUrl = process.env.REACT_APP_CONTENT_VOD;
        const token = encodeURIComponent(getToken());
        const mediaChannelURL = `${baseUrl}api/v1/media_channel_vod/${channelId}/master.m3u8?token=${token}`;

        await this.validatePlaylist(mediaChannelURL);

        ReactDOM.render(
            <MediaChannelVOD
                {...this.state}
                playerError={this.playerError}
                vodUrl={mediaChannelURL}
                done={this.raiseDone}
                error={this.onError}
                warning={(warning) => { console.error('warning', warning); }}
                solveError={this.solveError}
            />, this.node);
    }

    async preload () {
        await this.renderMediaChannelVOD();
        return super.preload();
    }

    static appliesTo({ isMediaChannelYoutube }){
        return HwFeatureService.supportMediaChannelVod(isMediaChannelYoutube);
    }
}


StateFactory.register('jukin', MediaChannelVODState, 20);
